/**
 * NOWROCKY™ — licznik statystyk + slider opinii.
 * Port ze starego sklepu (React): StatCounter.tsx, AnimatedCounter.tsx, ReviewsSlider.tsx.
 *
 * Zasady portu (te same co w nowrocky-live.js):
 *  - zero zaleznosci i ZERO requestow: avatary to lokalny SVG w data-URI, nie DiceBear,
 *  - tresc siedzi w blokach sekcji (Liquid), wiec Translate & Adapt ja tlumaczy,
 *  - szanujemy prefers-reduced-motion: bez animacji pokazujemy od razu wartosc koncowa.
 */
(function () {
  'use strict';

  /* Obie sekcje (licznik i opinie) dolaczaja ten sam plik, wiec przegladarka wykonuje
     go DWA razy — bez tej blokady powstawalyby podwojne obserwatory i podwojne
     nasluchy scrolla. boot() i tak obsluguje wszystkie sekcje na stronie naraz. */
  if (window.__NWR_SECTIONS_BOOTED__) return;
  window.__NWR_SECTIONS_BOOTED__ = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================= 1. LICZNIK ================================================
     Oryginal (StatCounter.parseValue) obslugiwal tylko sufiksy K/M/B, wiec "3MLN+"
     i "3000L+" NIE animowaly sie wcale. Tutaj rozbijamy wartosc na czesc liczbowa
     i dowolny ogon, dzieki czemu animuja sie wszystkie. Separator dziesietny
     zapamietujemy z wejscia (", " albo ".") i oddajemy taki sam — inaczej "99,9%"
     zrobiloby sie "99.9%" i rozjechalo z polska pisownia w kaflu obok. */
  function parseValue(raw) {
    var m = String(raw).match(/^(\D*?)(\d+(?:[.,]\d+)?)(.*)$/);
    if (!m) return null;
    var numRaw = m[2];
    var sepMatch = numRaw.match(/[.,]/);
    var sep = sepMatch ? sepMatch[0] : '';
    var decimals = sep ? numRaw.split(sep)[1].length : 0;
    var target = parseFloat(numRaw.replace(',', '.'));
    if (isNaN(target)) return null;
    return { prefix: m[1], target: target, suffix: m[3], decimals: decimals, sep: sep || ',' };
  }

  function fmt(n, p) {
    var s = p.decimals ? n.toFixed(p.decimals) : String(Math.round(n));
    if (p.decimals) s = s.replace('.', p.sep);
    return p.prefix + s + p.suffix;
  }

  /* Symbole +, %, / na czerwono — jak w oryginale (litery K/M/L zostaja czarne). */
  function paint(el, text) {
    el.textContent = '';
    var parts = String(text).split(/([+%/])/);
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      var span = document.createElement('span');
      if (/^[+%/]$/.test(parts[i])) span.className = 'nwr-sym';
      span.textContent = parts[i];
      el.appendChild(span);
    }
  }

  function animate(el, p, duration) {
    var start = null;
    function step(now) {
      if (start === null) start = now;
      var t = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);           // ease-out cubic, jak w oryginale
      paint(el, fmt(p.target * eased, p));
      if (t < 1) requestAnimationFrame(step);
      else paint(el, fmt(p.target, p));
    }
    requestAnimationFrame(step);
  }

  function initStats(root) {
    var cells = root.querySelectorAll('[data-nwr-stat]');
    if (!cells.length) return;
    var duration = parseInt(root.getAttribute('data-nwr-duration') || '1600', 10);

    Array.prototype.forEach.call(cells, function (cell) {
      var valEl = cell.querySelector('[data-nwr-stat-val]');
      if (!valEl) return;
      var p = parseValue(valEl.getAttribute('data-nwr-value') || valEl.textContent);
      if (!p) return;                                // np. "24/7" — zostaje jak jest

      if (REDUCED) { paint(valEl, fmt(p.target, p)); return; }

      paint(valEl, fmt(0, p));
      var done = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !done) { done = true; io.disconnect(); animate(valEl, p, duration); }
        });
      }, { threshold: 0.3 });
      io.observe(cell);
    });
  }

  /* ================= 2. OPINIE ================================================= */

  /* Avatar bez zadnego requestu — ten sam pomysl co w nowrocky-live.js.
     Deterministyczny: ten sam autor => zawsze ta sama twarz. */
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function rngFrom(seed) {
    var a = seed >>> 0;
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  var AV_BG = ['#1c1c1c', '#262626', '#333', '#454545', '#5a5a5a', '#c9c9c9', '#dedede', '#efefef'];
  function avatar(seed, accent) {
    var r = rngFrom(hash(seed));
    var useRed = r() < 0.16;
    var bg = useRed ? (accent || '#dc143c') : AV_BG[Math.floor(r() * AV_BG.length)];
    var lum = parseInt(bg.slice(1, 3), 16);
    var fg = lum > 150 ? '#0a0a0a' : '#f4f4f4';
    var hy = 17 + Math.floor(r() * 3);
    var hr = 8 + Math.floor(r() * 2);
    var svg = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'>"
      + "<rect width='48' height='48' fill='" + bg + "'/>"
      + "<circle cx='24' cy='" + hy + "' r='" + hr + "' fill='" + fg + "'/>"
      + "<path d='M6 46c0-10 8-16 18-16s18 6 18 16z' fill='" + fg + "'/>"
      + "</svg>";
    return 'data:image/svg+xml,' + encodeURIComponent(svg);
  }

  function initReviews(root) {
    var track = root.querySelector('[data-nwr-rev-track]');
    if (!track) return;
    var cards = track.querySelectorAll('[data-nwr-rev-card]');
    if (!cards.length) return;

    // avatary generujemy tu, nie w Liquid — data-URI w HTML puchlby przy kazdym renderze
    var accent = root.getAttribute('data-nwr-accent') || '#dc143c';
    Array.prototype.forEach.call(root.querySelectorAll('[data-nwr-av]'), function (img) {
      img.src = avatar(img.getAttribute('data-nwr-av') || 'nwr', accent);
    });

    var curEl = root.querySelector('[data-nwr-rev-cur]');
    var total = cards.length;

    function sync() {
      var w = cards[0].offsetWidth;
      if (!w) return;
      var idx = Math.round(track.scrollLeft / w);
      idx = Math.max(0, Math.min(total - 1, idx));
      if (curEl) curEl.textContent = String(idx + 1).replace(/^(\d)$/, '0$1');
    }

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });

    Array.prototype.forEach.call(root.querySelectorAll('[data-nwr-rev-go]'), function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-nwr-rev-go') === 'next' ? 1 : -1;
        track.scrollBy({ left: cards[0].offsetWidth * dir, behavior: REDUCED ? 'auto' : 'smooth' });
      });
    });

    sync();
  }

  /* ================= start + wsparcie edytora motywu ========================== */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-nwr-stats]').forEach(initStats);
    (scope || document).querySelectorAll('[data-nwr-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  // przeladowanie sekcji w edytorze motywu — inaczej po edycji bloku licznik zostaje na zerach
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
